import { api } from './client';

export type StaticUsdtSlot = {
  allowlist_id: number;
  batch_id: number;
  batch_code: string;
  register_date: string;
  user_id: number;
  username: string;
  is_sub: boolean;
  quota_usd: string;
  used_usd: string;
  reserved_usd: string;
  remaining_usd: string;
  wallet_address: string | null;
  wallet_from_master?: boolean;
  ep1_balance: string;
  ep1_from_master?: boolean;
  can_apply?: boolean;
};

export type StaticUsdtMe = {
  eligible: boolean;
  household_mode?: boolean;
  master_wallet?: string | null;
  master_ep1?: string;
  slots: StaticUsdtSlot[];
  primary: StaticUsdtSlot | null;
  wallet_address: string | null;
  ep1_balance: string;
  pending_requests: Array<{
    id: number;
    amount_usd: string;
    status: string;
    create_time: string;
    username?: string;
  }>;
};

export const staticUsdtPayoutAPI = {
  me: (params?: { account_id?: number }) =>
    api.get<StaticUsdtMe>('/api/static-usdt-payout/me', params),
  listRequests: () =>
    api.get<{ rows: Array<Record<string, unknown>> }>('/api/static-usdt-payout/requests'),
  create: (body: {
    amount_usd?: string;
    allowlist_id?: number;
    for_user_id?: number;
    transaction_password: string;
  }) => api.post('/api/static-usdt-payout/requests', body),
  applyAll: (body: { transaction_password: string }) =>
    api.post<{
      total: number;
      ok_count: number;
      fail_count: number;
      results: Array<{ username: string; ok: boolean; error?: string }>;
    }>('/api/static-usdt-payout/requests/apply-all', body),
  cancel: (id: number) => api.post(`/api/static-usdt-payout/requests/${id}/cancel`, {}),
};
